import Cookies from "js-cookie";

const permission = {
  state: {
    theme: "409EFF", //主题色，用于改变当前主题
    themeInfo: [
      {
        themeColor: "303133",
        name: "酷炫雅黑"
      },
      {
        themeColor: "409EFF",
        name: "深邃蔚蓝"
      },
      {
        themeColor: "31C0AD",
        name: "郁郁青葱"
      },
      {
        themeColor: "FFBE40",
        name: "活力蜜橙"
      },
      {
        themeColor: "FF3A61",
        name: "茜素深红"
      }
    ],
    isCollapse: document.documentElement.clientWidth < 800 ? true : false //是否折叠sidebar
  },
  mutations: {
    setTheme: (state, theme) => {
      //切换主题进行的操作
      if (!theme) {
        theme = "409EFF";
      }
      document.body.className = "custom-" + theme;
      Cookies.set("theme", theme, "1y");
      state.theme = theme;
    },
    changeSidebar: (state, isCollapse) => {
      //折叠,开启sidebar
      if (isCollapse) {
        state.isCollapse = isCollapse;
      } else {
        if (state.isCollapse) {
          state.isCollapse = false;
        } else {
          state.isCollapse = true;
        }
      }
    }
  },
  actions: {}
};

export default permission;
